import {inject, injectable, IServiceConfig, RestService} from "@athena-portal/core";
import {Types} from "../../Types";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {AjaxResponse} from "rxjs/ajax";
import {IFerryConvenienceApiService} from "../IFerryConvenienceApiService";

@injectable()
export class FerryConvenienceApiServiceImpl extends RestService implements IFerryConvenienceApiService {

    private configuration: IServiceConfig;

    constructor(@inject(Types.FerryConvenienceApiServiceConfig) configuration: IServiceConfig,) {
        super();
        this.configuration = configuration;
    }

    public getVehicleManufacturerDetails(partialVehicleManufacturer: string): Observable<string[]> {
        return this.doRequest<string[]>(`/vehicle-manufacturer-lookup?partialVehicleManufacturer=${partialVehicleManufacturer}`)
    }

    public getVehicleShortenedModelDetails(manufacturer: string, shortenedModel: string): Observable<any> {
        const queryParams: string = `vehicleManufacturer=${manufacturer}&vehicleShortenedModel=${shortenedModel}`;
        return this.doRequest<any>(`/vehicle-shortened-model-lookup-annual?${queryParams}`);
    }

    private doRequest<T> (urlAppend: string, method?: string, body?: any, onErrorReturn?: T): Observable<T>{
        return super.getProtectedResource({
            body,
            method: method || "GET",
            headers: this.configuration.customHeaders,
            url: `${this.configuration.serviceBaseUrl}${urlAppend}`,
        }, this.configuration.customQueryStringParameters, false).pipe(
            map((response: AjaxResponse): T => {
                    return response.response;
                }
            )
        );
    }
}
